import { Field, TextOutput } from '../../../Core';
import { WorksheetEquipmentDropdown } from '../WorksheetDropdowns';
import { useSelector } from 'react-redux';
import { FieldSet } from 'Components/Layout';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { Guid } from 'Lib/Guid';
import { IFieldProps } from 'Components/Core/Field/types';
import { hasValue } from 'Lib/Any';

type WorksheetBalanceFieldSetProps = Omit<
  IFieldProps,
  'equipmentType' | 'importModel' | 'importAdditionalData' | 'input'
>;

/**
 * A field set that wraps a balance equipment selection with additional common fields
 * Note the properties of this component (and in particular the "name") apply to the balance selection.
 */
let WorksheetBalanceFieldSet: React.FC<WorksheetBalanceFieldSetProps> = (
  /**
   * All properties of this component are passed through as Field properties for the Balance field.
   * Currently the other fields in the set are fixed and can't be customised.
   * If additional props are added specific to this component, ensure you only pass the correct props through to the
   * balance field.
   */
  props
) => {
  const { createWorksheetSelector, name } = props;
  const balanceUom = useSelector(createWorksheetSelector!(`${name}.Results.Uom`));
  const balanceReadability = useSelector(createWorksheetSelector!(`${name}.Results.Readability`));
  const importedReadabilityMismatch = useSelector(createWorksheetSelector!(`${name}.Mismatch`));
  const balanceId = useSelector(createWorksheetSelector!(`${name}.Id`)) as Guid;

  return (
    <FieldSet>
      <Field
        {...props}
        input={<WorksheetEquipmentDropdown />}
        importedAdditionalData={{
          Mismatch: importedReadabilityMismatch,
          Readability: balanceReadability,
          Uom: balanceUom,
        }}
        importModel={{
          Id: balanceId,
        }}
        equipmentType="balance"
      />

      <Field
        input={<TextOutput />}
        label="Readable to Nearest"
        labelUom={balanceUom}
        name={`${name}.Results.Readability`}
        visible={hasValue(balanceUom) && hasValue(balanceReadability)}
      />
    </FieldSet>
  );
};

WorksheetBalanceFieldSet = withInjectedProps(WorksheetBalanceFieldSet);
export { WorksheetBalanceFieldSet };
export default WorksheetBalanceFieldSet;
